@if (loginDisplay){
  <div style="display: flex; flex-direction: column; overflow-y: hidden;">
    <div style="min-height: 100%; display: flex; flex-direction: column; overflow-y: hidden;">
      <tds-header>
        <tds-header-hamburger
          id="str-hamburger"
          aria-label="Open application drawer"
          aria-haspopup="true"
          aria-expanded="false"
          (click)="toggleMobileSideMenu()">
        </tds-header-hamburger>

        <tds-header-title style="cursor: pointer;" (click)="gotoPage(0, 'home')">
          Scania Time Reporting
        </tds-header-title>

        <tds-header-item [selected]="getSelected(0)" *ngIf="isLoggedIn()">
          <button (click)="gotoPage(0, 'home')">
            Home
          </button>
        </tds-header-item>

        <tds-header-item [selected]="getSelected(1)" *ngIf="isLoggedIn()">
          <button (click)="gotoPage(1, 'createtimecard')">
            Create
          </button>
        </tds-header-item>

        <tds-header-item [selected]="getSelected(2)" *ngIf="isLoggedIn()">
          <button (click)="gotoPage(2, 'recenttimecards')">
            Submitted / Transferred
          </button>
        </tds-header-item>

        <tds-header-item [selected]="getSelected(3)" *ngIf="isLoggedIn()">
          <button (click)="gotoPage(3, 'reports')">
            Reporting
          </button>
        </tds-header-item>

        <tds-header-item [selected]="getSelected(4)" *ngIf="isLoggedIn() && loggedAccount.sysAdmin">
          <button (click)="gotoPage(4, 'sysadmin')">
            System admin
          </button>
        </tds-header-item>

        <tds-header-brand-symbol slot="end">
          <a aria-label="Scania - red gryphon on blue shield" href="https://www.scania.com/" target="_blank"></a>
        </tds-header-brand-symbol>
      </tds-header>
    </div>
    <div style="display: flex; flex-grow: 1; overflow-y: hidden;">
      <tds-side-menu
        aria-label="Side menu"
        open="{{ mobileNavOpen }}">
        <tds-side-menu-overlay
          slot="overlay"
          (click)="toggleMobileSideMenu()">
        </tds-side-menu-overlay>

        <tds-side-menu-close-button
          slot="close-button"
          (click)="toggleMobileSideMenu()">
        </tds-side-menu-close-button>

        <tds-side-menu-item [selected]="getSelected(0)" *ngIf="isLoggedIn()">
          <a (click)="toggleMobileSideMenu(); gotoPage(0, 'home')">
            Home
          </a>
        </tds-side-menu-item>

        <tds-side-menu-item [selected]="getSelected(1)" *ngIf="isLoggedIn()">
          <a (click)="toggleMobileSideMenu(); gotoPage(1, 'createtimecard')">
            Create
          </a>
        </tds-side-menu-item>

        <tds-side-menu-item [selected]="getSelected(2)">
          <a (click)="toggleMobileSideMenu(); gotoPage(2, 'recenttimecards')">
            Submitted / Transferred
          </a>
        </tds-side-menu-item>

        <tds-side-menu-item  *ngIf="isLoggedIn()" [selected]="getSelected(3)">
          <a (click)="toggleMobileSideMenu();  gotoPage(3, 'reports')">
            Reporting
          </a>
        </tds-side-menu-item>

        <tds-side-menu-item [selected]="getSelected(4)" *ngIf="isLoggedIn() && loggedAccount.sysAdmin">
          <a (click)="toggleMobileSideMenu();  gotoPage(4, 'sysadmin')">
            System admin
          </a>
        </tds-side-menu-item>

        <tds-side-menu-collapse-button slot="sticky-end"></tds-side-menu-collapse-button>
      </tds-side-menu>
    </div>
    <div *ngIf="isTestEnv()" style="padding-left:32px;text-align: left; background-color: crimson;color: yellow;height: 40px;">
      <H3 style="margin-top: 8px;">TEST-SYSTEM</H3>
    </div>
    <div *ngIf="isDevEnv()" style="padding-left:32px;text-align: left; background-color: darkorange;color: white;height: 40px;">
      <H3 style="margin-top: 8px;">LOCALHOST</H3>
    </div>
  </div>
  <div *ngIf="!isLoggedIn() && isSystemAvailable" class="page-spinner-container" >
    <div class="page-spinner tds-headline-06 ">
      <tds-spinner size="lg" variant="standard" style="margin-top: 64px;"></tds-spinner>
      <div class="tds-u-p2 tds-u-mt2 spinner-message ">
        STR is starting up, please wait
      </div>
    </div>
  </div>

  <section class="col-md-12">
    <router-outlet></router-outlet>
  </section>
} @else {
  <section class="landing-page">
    <img src="scania-logo.svg" alt="Scania">
    <h1>SCANIA TIME REPORTING</h1>
  </section>
}
